var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8499 15.1883L14.8717 15.3961L15.8499 15.1883L14.1506 7.18833L13.1747 7.39561L14.1506 7.18832C14.0034 6.49547 13.3916 6 12.6833 6H4.31671C3.6084 6 2.99662 6.49548 2.84945 7.18833L1.1501 15.1883C0.951905 16.1214 1.6635 17 2.61737 17H14.3826C15.3365 17 16.0481 16.1214 15.8499 15.1883Z",
    stroke: "#003393",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6V4C11 3 10.5 1 8.5 1C6.5 1 6 3 6 4V6",
    stroke: "#003393",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11L7.5 13L11.5 9.5",
    stroke: "#003393",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.82be489b89a00564a5590bb5517fd1e9.svg";
export { ForwardRef as ReactComponent };